module.exports = __webpack_public_path__ + "img/26.372fcca3.svg";